import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProduct } from "../../api/product.api";
import { toast } from "react-toastify";
import { productKeys } from "../../queryKeys";

interface UpdateProductPayload {
  name?: string;
  category?: string;
  description?: string;
  price?: number;
  benefits?: string[];
  thumbnail?: string;
};

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateProductPayload;
    }) => updateProduct(payload, id),

    onSuccess: (res) => {
      if (res?.message?.toLowerCase() === "success") {
        toast.success("Product updated successfully!");

        // Invalidate product list
        queryClient.invalidateQueries({
          queryKey: productKeys.all,
        });

        // Optional: invalidate single product if you cache it
        // queryClient.invalidateQueries({
        //   queryKey: ["product", res?.data?.id],
        // });
      }
    },

    onError: (error: any) => {
      console.error(error);
      toast.error("Failed to update product!");
    },
  });
};
